import * as React from 'react';
import './index.scss';
import Mock from 'mockjs'
const { useState, useEffect } = React;
const lunboData = () => {
  const data: any[] = [];
  let index = 100;
  while (index >= 0) {
    const member = Mock.Random.natural(5, 99);
    const moneyList = new Array(member).fill(Mock.Random.natural(10, 20));
    const money = moneyList.reduce((prev, next) => prev + next);
    data.push(Mock.mock({
      name: Mock.Random.boolean() ? Mock.Random.last() : Mock.Random.cfirst(),
      member,
      money,
    }))
    index -= 1;
  }
  return data;
}
const TitleRun: React.FC = () => {
  const [mockDatas] = useState<any>(lunboData());
  const [mockData, setMockData] = useState<any>(lunboData()[0]);
  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      index += 1;
      if (index >= 100) {
        index = 0;
      }
      setMockData(mockDatas[index]);
    }, 8000)
    return () => {
      clearInterval(timer);
    }
  }, [])
  return (
    <div className='title-run in'>
      <span>{mockData.name}****</span>已邀请<span>{mockData.member}</span>人，成功赚到<span>{mockData.money}</span>元
    </div>
  )
}

export default TitleRun;